export default {
  siteName: "琉璃神社",
  home: "首页",
  gallery: "精选图集",
  styles: "画风鉴赏",
  about: "关于我们",
  faq: "常见问题",
  contact: "联系我们",
};